import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './zh'
import en from './en'
import hk from './hk'
import kor from './kor'
import jp from './jp'
import th from './th'
import ind from './indonesia'
let locale = window.localStorage.getItem('locale') || 'ind';
if(locale == ''){
  locale = 'ind';
  window.localStorage.setItem('locale','ind');
}
export default new VueI18n({
  locale:locale,
  messages:{
    kor:kor,
    zh:zh,
    en:en,
    hk:hk,
    jp:jp,
    th:th,
    ind:ind
  }
})


// WEBPACK FOOTER //
// ./src/lang/lang.js